import { TeamTypeArray } from '../types/OurTeams.type';

export const OurTeamsData: TeamTypeArray = [
  {
    team: 'Product & User Experience Design',
    description: 'Our Product & UX Design team focuses on creating intuitive, user-friendly interfaces that enhance the overall user experience. They blend creativity with research-driven insights to develop products that are both functional and visually engaging, ensuring every touchpoint resonates with our users.',
  },
  {
    team: 'Front End Engineering',
    description: 'Our Front End Engineering team brings designs to life through clean, efficient, and scalable code. They specialize in building dynamic and responsive user interfaces using the latest technologies, ensuring seamless interaction and top-tier performance across devices.',
  },
  {
    team: 'Back End Engineering',
    description: 'The Back End Engineering team powers our applications from behind the scenes. They develop robust, secure, and scalable server-side logic, manage databases, and ensure smooth data flow between the server and the user, creating a strong foundation for all our products.',
  },
  {
    team: 'DevOps Engineering',
    description: 'Our DevOps Engineering team bridges the gap between development and operations, ensuring efficient deployment and integration processes. They focus on automating workflows, maintaining infrastructure, and optimizing performance, allowing our teams to deliver high-quality products quickly and reliably.',
  },
];






